import { type ProductMarketType } from "../models/ProductData";

export interface MessageModel {
  type: "info" | "error" | "warning";
  code: string;
  params: Dict<string>;
}

export interface PreviewItem {
  id: number;
  quantity: number;
  quantityVisible: boolean;
  productId: string;
  requestedDeliveryDate?: Date;
  comment: string;
  isCommentVisible: boolean;
  messages: MessageModel[];
  priceReference: string;
  marketType: ProductMarketType | null;
  succeedingProductDesignation: string;
  succeedingProductUrl: string;
  customerOrderNumber: string;
  previousProductId?: string;
  onSale: boolean;
}

export interface PreviewItemUpdateData
  extends Pick<
    PreviewItem,
    | "quantity"
    | "requestedDeliveryDate"
    | "comment"
    | "isCommentVisible"
    | "priceReference"
    | "previousProductId"
    | "succeedingProductDesignation"
    | "customerOrderNumber"
  > {
  designation: string;
  sapMaterialNumber: string;
  inputText: string;
  productId: string;
  marketType?: ProductMarketType | null;
}

export enum BulkUploadState {
  INITIAL,
  UPLOADING,
  ERROR,
  UPLOAD_SUCCESS,
  LOADING_CART,
  ERROR_CART,
}

export enum BulkUploadSource {
  FILE,
  TEXT,
}

export interface Msg {
  type: "warn" | "info" | "error";
  label: string;
}
